var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[(_vm.isAppLoaded)?_c('keep-alive',{attrs:{"include":['AlumniList', 'Association']}},[_c('router-view')],1):_c('v-overlay',[_c('v-progress-circular',{attrs:{"size":"64","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }